import React, { useState, useContext, createContext } from "react";

const GetVideoTimeContext = createContext();

//
// 1 - Provider => state
// 2 - Consumer

export const GetVideoTimeContextProvider = ({ children }) => {
  const videoState = useState({
    duration: 0,
    currentTime: 0,
    isCompleted: false,
  });

  return (
    <GetVideoTimeContext.Provider value={videoState}>
      {children}
    </GetVideoTimeContext.Provider>
  );
};

export default useGetVideoTimeContext = () => useContext(GetVideoTimeContext);
